export default class Collection {

    constructor(collection){
        console.log("🚀 ~ file: Collection.js:4 ~ Collection ~ constructor ~ collection:", collection)
        const keys = Object.keys((collection==null)?{}:collection);
        this.payment_method = (keys.includes("payment_method"))? collection.payment_method: "";
        this.payment_frequency = (keys.includes("payment_frequency"))? collection.payment_frequency: "";
    }
}